module.exports = __webpack_public_path__ + "static/media/TestimonialHeader.8f62423e.webp";